import React, { useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import ButtonYesno from "../../../components/buttons/button.yesno";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import {ToolTipPerso} from "../../../components/selects/tooltip_perso";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";

// simulateur Id 18

function Simulateur_ESD(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const [montantLot1, setMontantLot1] = useState(0);
  const [montantLot2, setMontantLot2] = useState(0);

  const handleChange = async (setter, value) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else setter(value);
    setInRedux(setter, value);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };
  function setInRedux(setter, value) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          montant_deb_add: parseInt(montantDeboursAdditionnels), 
          debours_additionnels: parseInt(deboursAdditionnels),
          montant_lot_1: parseInt(montantLot1),
          montant_lot_2: parseInt(montantLot2),
          convention_honoraires : parseInt(props.conventionHonoraires),
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
        },
        pdfInputs: {
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
          nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
          adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
      };

      if (setter === setDepartement) {
        object.departementid = parseInt(value);
      }

      if (setter === setDeboursAdditionnels) {
        Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
      }

      if (setter === setMontantDeboursAdditionnels) {
        Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
      }

      if (setter === setMontantLot1) {
        Object.assign(object["inputs"], { montant_lot_1: parseInt(value) });
      }

      if (setter === setMontantLot2) {
        Object.assign(object["inputs"], { montant_lot_2: parseInt(value) });
      }

      if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }

      if (setter === props.setNombreConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
      }

      if (setter === props.setObjectConventionHonoraires) {
        Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
      }

      if (setter === props.setMontantConventionHonoraires) {
        Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
      }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }

      dispatch(setSimulateurObject(object));
    } else {
      // process child simu
    }
  }

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>Acte tarifé au titre du Tableau 5, n° 96 (Art A444-117)</p>

        {props?.isParent === true && props.departements !== "" ? (
          <>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Département :</div>

              <SelectDepartement
                items={props.departements}
                nameField={"name"}
                defaultValue={currUserDep}
                optionValue={"id"}
                handleChange={handleChange}
                setter={setDepartement}
              />
            </div>
            <div style={styles.cardRowSpecialMessage}>
              La taxe départementale utilisée pour vos calculs est bien celle qui a été votée dans votre département. Attention de bien penser à indiquer le bon département lorsque vous effectuez une vente sur un département qui n’est pas le votre.
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Y a-t-il des débours additionnels à prévoir ?
            <ToolTipPerso
                title={
                  "Les débours comprennent une somme de 120 euros représentant le coût moyen d'obtention d'un certificat d'urbanisme complet. Pour retirer ce coût, répondre 'non' à la question."
                }
            />
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setDeboursAdditionnels} fieldUndefined={true} defaultValue={2} />
          </div>
        </div>

        {parseInt(deboursAdditionnels) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Montant des débours additionnels :</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantDeboursAdditionnels}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quel est le montant du lot échangé dont la valeur est la plus élevée ?
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantLot1}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quel est le montant du lot échangé dont la valeur est la plus faible ?
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantLot2}
          />
        </div>

        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_ESD;
